import { connect } from 'react-redux';
import sortBy from 'lodash/sortBy';
import { formValueSelector } from 'redux-form';
import { TaggingField } from 'common/components/form_fields';
import { getSubCategories, excludeDeprecated } from 'common/ducks/categories';

export function mapStateToProps(state, {
  value, formName, includeAllOption, include1to1Option, input: { name }
}) {
  const categories = excludeDeprecated(state.categories.data).filter(c => !c.is_one_to_one);
  const subcategories = sortBy(getSubCategories({ data: categories }), 'name');
  let selector, formValue;
  const options = subcategories.map(cat => ({ label: cat.name, value: cat.id }));

  if (include1to1Option) {
    options.unshift({ label: "1-to-1", value: "1to1" });
  }

  if (includeAllOption) {
    options.unshift({ label: "All", value: "all" });
  }

  if (formName) {
    selector = formValueSelector(formName);
    formValue = selector(state, name);
  }

  return {
    options,
    value: formName? formValue : value,
    clearable: false
  };
}

export default connect(mapStateToProps)(TaggingField);
